export default __webpack_public_path__ + "static/media/close.f86258c3.svg";